export const WidgetConstants = {
  TYPE_PROMOTIONS: 0,
  TYPE_CATEGORY_WIDGET: 1,
  TYPE_PROMOTIONS_BANNER: 4,
  TYPE_HORIZONTAL_PRODUCT_LIST_WIDGET: 21,
  TYPE_BANK_OFFERS: 22,
  TYPE_HEADER_STATUS_WIDGET: 26,
  TYPE_CAROUSEL_PARENT: 28,
  TYPE_MEMBERSHIP_HEADER_WIDGET: 41,
  TYPE_TITLE_HORIZONTAL_PRODUCT_LIST: 31,
  TYPE_MEMBERSHIP_SKU: 33,
  TYPE_USER_ACTION: 39,
  TYPE_QA: 40,
  TYPE_CTA: 43,
  TYPE_COPY_CODE: 45,
  TYPE_REFERRAL_PRODUCT_LIST_WIDGET: 47,
  TYPE_REFERRAL_COINS_MASTHEAD_WIDGET: 48,
  TYPE_DEAL_LIST_WIDGET: 49,
  TYPE_MULTI_IMAGE: 52,
  TYPE_BANNER_WIDGET: 55,
  TYPE_ANNOUNCEMENT: 60,
  TYPE_SALE_COUPON: 64,
  TYPE_GOBD_COUNTDOWN: 65,
  TYPE_SALE_COUPON_LIST: 66,
  CLICK_DEALS_PRODUCT_WIDGET: 67,
  CLICK_DEALS_CLICKS_PRICE_WIDGET: 68,
  TYPE_APPLY_COUPON: 69,
  TYPE_PLP_GRID_WIDGET: 70,
  TYPE_PRIMARY_CTA: 71,
  TYPE_WINWIN_REWARDS_WIDGET: 72,
  TYPE_GOBD_CARD_GAME_WIDGET: 73,
  TYPE_NUMBER_SEPATATOR_WIDGET: 74,
  TYPE_GOBD_WINNERS_WIDGET: 75,
  TYPE_CUSTOM_PRODUCT_WIDGET: 106,
  TYPE_PLP_PRODUCT_WIDGET: 102,
  TYPE_PLP_FEEDBACK_WIDGET: 103,
  TYPE_YOUTUBE_VIDEO_WIDGET: 76,
  TYPE_CATEGORIES_SLIDER_WIDGET: -100,
  TYPE_FOOTER_WIDGET: -101,
  TYPE_SLIDER_PRODUCT_LIST: 77,
  TYPE_SBC_SAVINGS_WIDGET: 78,
  TYPE_LIST_WITH_BULLETS_WIDGET: 83,
  TYPE_TEXT_ICON_WIDGET: 56,
  TYPE_TEXT_BANNER_WIDGET: 80,
  TYPE_ORDER_PLACED_WIDGET: 84,
  TYPE_ORDER_DETAILS_WIDGET: 81,
  TYPE_SBC_TRIAL_WIDGET: 85,
  TYPE_LIVE_ORDER_WIDGET: 86,
  TYPE_ORDER_HISTORY_WIDGET: 87,
  TYPE_ORDER_STATUS_WIDGET: 88,
  TYPE_PAYMENT_MODE_STRIP: 89,
  TYPE_ORDER_ITEM_DETAIL: 90,
  TYPE_DELIVERY_ADDRESS_WIDGET: 105,
  TYPE_CANCEL_ORDER_WIDGET: 100,
  TYPE_PAYMENT_SUMMARY_WIDGET: 104,
  TYPE_LUCKY_DRAW_WIDGET: 107,
  TYPE_AUTO_REFRESH_WIDGET: 108,
  TYPE_INFO_STRIP_WIDGET: 109,
  TYPE_REWARD_WIDGET: 110,
  TYPE_SEARCH_INTERVENTION_WIDGET: 101,
  TYPE_BOLD_TEXT_ICON_WIDGET: 111,
  TYPE_SOCIAL_SHARE_WIDGET: 36,
  TYPE_SBC_SAVING_WIDGET: 37,
  TYPE_SHIPMENT_SLOT_WIDGET: 114,
  TYPE_CART_ADDRESS_CHECKOUT_WIDGET: 115,
  TYPE_MEMBERSHIP_CARD_WIDGET: 116,
  TYPE_MOV_METER_WIDGET: 117,
  TYPE_BILL_CARD_WIDGET: 118,
  TYPE_ZERO_ITEM_INLINE_WIDGET: 119,
  TYPE_TIP_WIDGET: 121,
  TYPE_TITLE_CTA_WIDGET: 122,
  TYPE_CART_PRODUCT_WIDGET: 123,
  TYPE_TIME_ORDER_WIDGET: 124,
  TYPE_HEADER_LIST_WIDGET: 113,
  TYPE_PROFILE_INFO_WIDGET: 112,
  TYPE_ETAWIDGET: 125,
  TYPE_PROMO_CODE_WIDGET: 126,
  TYPE_VIDEO_WIDGET: 127,
  TYPE_SAMPLE_PRODUCTS_WIDGET: 128,
  TYPE_TRENDING_SEARCH_WIDGET: 129,
  TYPE_WALLET_HEADER_WIDGET: 130,
  TYPE_WALLET_TRANSACTION_WIDGET: 131,
  TYPE_MULTIPLE_SHIPMENT_WIDGET: 132,
  TYPE_DELIVERY_TIME_WIDGET: 133,
  TYPE_ORDER_STATE_WIDGET: 134,
  TYPE_PAYMENT_ONLINE_WIDGET: 135,
  TYPE_SEARCH_BAR_WIDGET: 136,
  TYPE_LOCATION_BAR_WIDGET: 137,
  TYPE_VIDEO_PRODUCT_WIDGET: 138,
  TYPE_CHECKBOX_WITH_TEXT: 139,
  TYPE_SUGGESTED_KEYWORDS_WIDGET: 140,
  TYPE_PRODUCT_WIDGET: 141,
  TYPE_PRODUCT_DETAIL_REVIEW_WIDGET: 142,
  TYPE_PRODUCT_DETAIL_ADDITIONAL_INFO_WIDGET: 143,
  TYPE_PROMISE_TIME_WIDGET: 144,
  TYPE_HEADER_STRIP_WIDGET: 145,
  TYPE_MAP_WIDGET: 146,
  TYPE_ERROR_WIDGET: 147,
  TYPE_ASPIRATIONAL_PRODUCT_LIST: 148,
  TYPE_MULTI_INFORMATIVE_WIDGET: 149,
  TYPE_OOS_WIDGET: 150,
  TYPE_OOS_BOTTOM_SHEET_WIDGET: 151,
  TYPE_ORDER_ID_STRIP_WIDGET: 152,
  TYPE_ORDER_TIME_STATE_WIDGET: 153,
  TYPE_PAYMENT_WIDGET: 154,
  TYPE_TEXT_AREA_WIDGET: 155,
  TYPE_TEXT_INPUT_FIELD_WIDGET: 157,
  TYPE_SUBMIT_FORM_BUTTON_WIDGET: 158,
  TYPE_ORDER_STATUS_AND_ADDRESS_WIDGET: 160,
  TYPE_ORDERED_PRODUCT_CARD_WIDGET: 162,
  TYPE_REFUND_INFO_WIDGET: 164,
  TYPE_REORDER_BUTTON: 165,
  TYPE_VERTICAL_CATEGORY_CARD_WIDGET: 166,
  TYPE_PROMO_OFFER_CARD_WIDGET: 167,
  TYPE_PROMO_CART_STRIP_WIDGET: 168,
  TYPE_PROMO_INPUT_WIDGET: 169,
  TYPE_DELIVERY_PARTNER_INFO_WIDGET: 201,
  TYPE_FE_INSTRUCTIONS_WIDGET: 202,
  TYPE_FE_SAFETY: 203,
  TYPE_MAP_TRACKING_WIDGET: 204,
  TYPE_HEADER_WIDGET: 205,
  TYPE_ORDER_SUMMARY_BUTTON_WIDGET: 206,
  TYPE_ORDER_SUMMARY_WIDGET: 208,
  TYPE_CHAT_SUPPORT_HEADER_WIDGET: 209,
  TYPE_CHAT_SUPPORT_WIDGET: 210,
  TYPE_ORDER_SUMMARY_INFO: 211,
  TYPE_NO_ORDER_HISTORY_WIDGET: 212,
  TYPE_TOTAL_SAVINGS: 213,
  TYPE_CANCELLATION_POLICY: 214,
  TYPE_WALLET_DETAIL: 215,
  TYPE_PRODUCT_SHELF_WIDGET: 217,
  TYPE_CREDITS_STRIP_WIDGET: 218,
  TYPE_ADDRESS_DETAILS_WIDGET: 219,
  TYPE_SEARCH_HISTORY: 220,
  TYPE_RECENT_AND_TRENDING_WIDGET: 221,
  TYPE_FEATURE_DESCRIPTION_WIDGET: 224,
  TYPE_FAQ_WIDGET: 225,
  TYPE_PRINT_PREVIEW_WIDGET: 226,
  TYPE_PRINT_SETTINGS_WIDGET: 227,
  TYPE_INSTRUCTION_LIST_WIDGET: 229,
  TYPE_TITLE_SUBTITLE_WIDGET: 230,
  TYPE_HORIZONTAL_PRODUCT_DETAIL_WIDGET: 231,
  TYPE_USER_QUESTION_WIDGET: 232,
  TYPE_CANCEL_ORDER_POLICY_WIDGET: 233,
  TYPE_DELIVERY_PARTNER_TIP_WIDGET: 234,
  TYPE_CANCEL_ORDER_TIMER_WIDGET: 235,
  TYPE_TRACK_ORDER_BANNER_WIDGET: 236,
  TYPE_INFORMATION_STRIP: 238,
  TYPE_CART_CHECKOUT_STRIP: -102,
  TYPE_GIFT_ORDER_WIDGET: 237,
  TYPE_TIMELINE_DATA: 239,
  TYPE_POST_CHECKOUT_PAYMENT_WIDGET: 240,
  TYPE_PROMOTION_CARD_WIDGET: 241,
  TYPE_VIDEO_PRODUCT_CARD_WIDGET: 242,
  TYPE_VIDEO_BANNER_WIDGET: 243,
  TYPE_HORIZONTAL_PILLS_WIDGET: 244,
  TYPE_PILL_VIEW_WIDGET: 245,
  TYPE_POST_CHECKOUT_PAYMENT_COMPLETE_WIDGET: 246,
  TYPE_EMPTY_WIDGET: 247,
  TYPE_APP_RATING_WIDGET: 248,
  TYPE_VERTICAL_TEXT_IMAGE_WIDGET: 249,
  TYPE_STORE_MANAGER_INFO_WIDGET: 250,
  TYPE_OPEN_SCRATCH_CARD_TRACK_ORDER_WIDGET: 251,
  TYPE_REFER_AND_EARN_TRACK_ORDER_WIDGET: 252,
  TYPE_ORDERED_ITEMS_WIDGET: 253,
  TYPE_HORIZONTAL_PILL_VIEW: 254,
  TYPE_VERTICAL_FILTER_OPTION_WIDGET: 255,
  TYPE_DELIVERY_INSTRUCTION_WIDGET: 256,
  TYPE_RATING_WIDGET: 257,
  TYPE_ENABLE_NOTIFICATION_WIDGET: 258,
  TYPE_UNAVAILABLE_ITEMS_WIDGET: 259,
  TYPE_DELIVERY_PARTNER_SAFETY_WIDGET: 260,
  TYPE_HEADER_BRAND_WIDGET: 261,
  TYPE_B_IMAGE_TEXT_SNIPPET_TYPE_5: 262,
  TYPE_CHIP_GROUP_WIDGET: 263,
  TYPE_STORE_MANAGER_WIDGET: 264,
  TYPE_RECOMMENDATION_RAIL: 265,
  TYPE_SEPARATOR_V2_WIDGET: 266,
  TYPE_GIFT_WRAP_WIDGET: 270,
  TYPE_BOTTOM_BUTTONS_WITH_STRIP_INFO: 271,
  TYPE_PRODUCT_BMSM_WIDGET: 272,
  TYPE_BADGES_WIDGET: 273,
  TYPE_TITLE_WIDGET: 274,
  TYPE_FEEDING_INDIA_WIDGET: 275,
  TYPE_CRYSTAL_CAROUSEL_DATA: 276,
  TYPE_RIDER_RATING_WIDGET: 277,
  TYPE_PRINT_HEADER_BANNER: 278,
  TYPE_UPLOAD_CARD_WIDGET: 279,
  TYPE_PRINT_FEATURES_WIDGET: 280,
  TYPE_DELIVERY_DETAILS_WIDGET: 281,
  TYPE_DELIVERY_LOCATION_WIDGET: 282,
  TYPE_CONTACT_NUMBER_WIDGET: 283,
};

export const SnippetsType = {
  crystal_snippet_type_1: 'crystal_snippet_type_1',
  crystal_snippet_type_2: 'crystal_snippet_type_2',
  crystal_snippet_type_6: 'crystal_snippet_type_6',
  image_text_tag_snippet: 'image_text_tag_snippet',
  b_image_text_snippet_type_17: 'b_image_text_snippet_type_17',
  rider_tip_snippet: 'rider_tip_snippet',
  order_details_carousel: {
    widget_type: 'horizontal_list',
    data_key: 'horizontal_item_list',
  },
  track_order_vertical_banner_list: '',
  track_order_map_data: '',
  track_order_delivery_partner: '',
  track_order_delivery_partner_safety: '',
  'Pay Before Delivery Widget': '',
  crystal_banner_carousel: '',
  delivery_instructions_widget: '',
  track_order_delivery_details_header_widget: '',
  track_order_delivery_address_widget_v2: '',
  track_order_alternate_contact_number: '',
  track_order_chat_support: '',
  track_order_summary: '',
  track_order_summary_button: '',
  'App Rating Widget': '',
  crystal_pitstop_android_wicked_gud_0: '',
};
